import React from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  CodeDatatable = (props) => {

    const [t] = useTranslation();     
   // const [entityId, setEntityId] = useState();
    const tableName = t('general.label.codeList');     

    const columns = [       
             { name: "Id", data: "id", selector: "id", omit: true},
             { name: t('general.label.code'), data: "code", sortable: true, selector: "code"},    		             
             { name: t('general.label.description'), data: "description",  sortable: true,  selector: "description"}
             
     ];        
 
 
         
     const columnsData = [       
         { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
         { name: t('general.label.code'), data: "code",  orderable: true, searchable: true, search: {value: '',regex: false}},    		     
         { name: t('general.label.description'), data: "description", orderable: true,  searchable: true, search: {value: '',regex: false}}               
     ];        
     const url = RestService.getBaseURL()+"company/getCompanyCodeList";   
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 
   //  useEffect(() => {      
   //     setEntityId(props.entityId);
   //  }, [props.entityId])

     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
          
    
         return (
           <>
          {   <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={false}
             />
          }
          </>
         );
    
 
  
 };

export default CodeDatatable;

